import { useSnackbar } from 'notistack';
import { useState } from 'react';

interface Params {
  getCSVContent: () => Promise<string>;
  downloadFile: (csvContent: string) => void;
}

export function useDownloadData({ getCSVContent, downloadFile }: Params) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  return {
    loading,
    download: () => {
      setLoading(true);
      getCSVContent()
        .then((respose) => {
          downloadFile(respose);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          enqueueSnackbar('Unable to download data.', {
            variant: 'error',
            autoHideDuration: 4000,
          });
        });
    },
  };
}
